import React from "react";
import { observer } from "mobx-react-lite";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import HeaderRow from "@edaz/edazkit/HeaderRow/index";
import Button from "@edaz/edazkit/Button/index";
import DeadLetterTopicsViewModel from "viewModels/administration/deadLetterTopics/deadLetterTopicsViewModel";
import Tabs from "../../common/tabs";
import ProcessingMethod from "../../../entities/processingMethod";

const DeadLetterTopicsView: ViewComponent<DeadLetterTopicsViewModel> = observer(({ vm }) => {
  const approveSelectedEnabled = vm.activeChild?.self.selectedItems?.size ? vm.activeChild?.self.selectedItems.size : false;

  return (
    <>
      {vm.allowWrite && (
        <HeaderRow level={3} title={vm.name} className="mb-4">
          <Button className="rounded" size="sm" onClick={() => vm.onResubmissionSelectedClick(ProcessingMethod.ProcessAll)}>
            {vm.translate("resubmissionAll")}
          </Button>
          <Button
            className="rounded"
            size="sm"
            onClick={() => vm.onResubmissionSelectedClick(ProcessingMethod.ProcessSelected)}
            disabled={!approveSelectedEnabled}>
            {vm.translate("resubmissionSelected")}
          </Button>
          <Button
            className="rounded"
            variant="danger"
            size="sm"
            onClick={vm.onDiscardSelectedClick}
            disabled={!approveSelectedEnabled}>
            {vm.translate("discardSelected")}
          </Button>
        </HeaderRow>
      )}
      <Tabs vm={vm} />
    </>
  );
});

registerView(DeadLetterTopicsView, DeadLetterTopicsViewModel);
